module.exports = __webpack_public_path__ + "media/mariah.b954d21a.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/mariah.mp3
 ** module id = 561
 ** module chunks = 0
 **/